export const fridayAbbreviatedLowercase = "Fqa";
export default {fridayAbbreviatedLowercase};